export const authRoutes = {
  SIGN_IN: "sign_in",
  SIGN_UP: "new",
  RESET_PASSWORD: "password_resets/new",
};
